import { fromJS } from 'immutable';
import * as constants from './constants';
import R from 'ramda';


const initialState = fromJS({
  newsfeed: {
    list: [],
    unreadCount: null,
    unseenCount: null,
  },
  messaging: {
    count: 0,
  },
});

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case constants.GOT_NOTIFICATIONS:
    case constants.UPDATE_PROPS:
      return state.merge(fromJS(payload));
    case constants.MARKED_READ:
      return state.updateIn(['newsfeed', 'list'], list => list.filter(obj => {
        return (!R.contains(obj.get('id'), payload.activityIds));
      }));
    case 'DECREMENT_UNREAD_MESSAGES_COUNT':
      return state.setIn(['messaging', 'count'], Math.max(state.getIn(['messaging', 'count']) - 1, 0));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/notification/reducer.js